import { AxiosError } from 'axios'
import { useCallback, useContext, useState } from 'react'
import { FiX } from 'react-icons/fi'

import { Button } from '~/components/Button'
import { Modal } from '~/components/Modal'
import { deletePersonalTrainer } from '~/modules/admin/services'
import { insertToast } from '~/modules/toasts/services'

import { context as pageContext } from '../../../context'
import { context } from '../contex'

type Props = {
  visible: boolean
  onDismiss(): void
}

export const DeletePersonalTrainerModal: React.FC<Props> = ({
  visible,
  onDismiss,
}) => {
  const { handleRemoveFromList } = useContext(pageContext)
  const { personalTrainer } = useContext(context)
  const [loading, setLoading] = useState<boolean>(false)

  const handleDeletePersonalTrainer = useCallback(async () => {
    setLoading(() => true)
    deletePersonalTrainer(personalTrainer.id)
      .then((data) => {
        handleRemoveFromList(data.id)
      })
      .catch((e: AxiosError<APIError>) => {
        insertToast({
          duration: 4,
          title: 'Falha',
          message: e.response?.data.message ?? '',
          type: 'error',
        })
      })
      .finally(() => {
        setLoading(() => false)
      })
  }, [personalTrainer.id, handleRemoveFromList])

  return (
    <Modal visible={visible}>
      <div className='flex items-center justify-between mb-4'>
        <h1 className='text-xl'>Deletar Personal Trainer</h1>
        <button
          type='button'
          className='p-2 rounded-full hover:bg-slate-50'
          onClick={onDismiss}
        >
          <FiX size={26} />
        </button>
      </div>

      <div className='flex flex-col gap-6'>
        <p>
          Atenção! Lembre-se de que ao deletar um personal trainer, todos os
          seus dados serão apagados e a assinatura ativa será cancelada, junto
          com sua cobrança to termo vigente (caso não tenha sido finalizada)
        </p>

        <div className='flex items-center justify-center gap-4'>
          <Button
            color='error'
            loading={loading}
            onClick={handleDeletePersonalTrainer}
          >
            Prosseguir e deletar
          </Button>
          <Button mode='outlined' color='error' onClick={onDismiss}>
            Cancelar
          </Button>
        </div>
      </div>
    </Modal>
  )
}
